import Cookies from "js-cookie";

export const frameworkUrl = process.env.REACT_APP_FRAMEWORK;
export const projectUrl = process.env.REACT_APP_PROJECT;
export const evidenceUrl = process.env.REACT_APP_EVIDENCE;
export const evaluationUrl = process.env.REACT_APP_EVOLUTION;
export const reportUrl = process.env.REACT_APP_REPORT;
export const itgcUrl = process.env.REACT_APP_ITGC;

export async function handleFetchRequest(
    serverUrlRequest = "framework",
    url,
    method = "GET",
    data = null,
    password,
    formData,
    timeout = 180000 // 3 minutes default timeout
) {
    let serverUrl = "";
    let tokens = "abc"; //it should be null or empty string if no token is available
    let headers = {};
    let requestOptions = {};

    if (serverUrlRequest === "framework") {
        serverUrl = frameworkUrl;
    } else if (serverUrlRequest === "project") {
        serverUrl = projectUrl;
    } else if (serverUrlRequest === "evidence") {
        serverUrl = evidenceUrl;
    } else if (serverUrlRequest === "evaluation") {
        serverUrl = evaluationUrl;
    }else if (serverUrlRequest === "report") {
        serverUrl = reportUrl;
    } else if (serverUrlRequest === "itgc") {
        serverUrl = itgcUrl;
    }else {
        serverUrl = frameworkUrl; // default to framework if no match
    }

    if (Cookies.get("emp_token")) {
        tokens = Cookies.get("emp_token");
    }

    // Create AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    if (tokens && !password && !formData) {
        // tokens = Cookies.get("emp_token");
        headers = {
            Accept: "application/json",
            Authorization: "Bearer " + tokens,
            "Content-Type": "application/json",
        };

        requestOptions = {
            method: method,
            headers: headers,
            body: data ? JSON.stringify(data) : null,
            signal: controller.signal, // Add timeout signal
        };
    } else if (password) {
        headers = {
            Authorization: "Bearer " + tokens,
            "Content-Type": "application/json",
            ...password,
            Accept: "application/json",
            // 'ngrok-skip-browser-warning': 'true',
        };

        requestOptions = {
            method: method,
            headers: headers,
            body: data ? JSON.stringify(data) : null,
            signal: controller.signal, // Add timeout signal
        };
    } else if (formData) {
        headers = {
            Accept: "application/json",
            Authorization: "Bearer " + tokens,
            // 'Content-Type': `multipart/form-data`,
            // 'ngrok-skip-browser-warning': 'true',
        };
        requestOptions = {
            method: method,
            headers: headers,
            body: data ? data : null,
            signal: controller.signal, // Add timeout signal
        };
    }

    try {
        const response = await fetch(serverUrl + url, requestOptions);
        
        // Clear timeout if request completes successfully
        clearTimeout(timeoutId);
        
        const result = await response.json();
        return {
            ...result, statusCode: response.status
        }
    } catch (error) {
        // Clear timeout
        clearTimeout(timeoutId);
        
        // Handle timeout specifically
        if (error.name === 'AbortError') {
            return {
                error: 'Request timeout - operation took longer than expected',
                statusCode: 408
            };
        }
        
        // console.error('Error:', error.message);
        return {
            error: error.message,
            statusCode: 500
        };
    }
}